import { FunctionComponent } from 'react';
import classNames from 'classnames';

// Components
import Image from '@Components/Utils/Image';
import { Modal as RTModal, ModalBody } from 'reactstrap';
import { useServiceManager } from '../../../Contexts/service';
import { useViewDetected } from '@Components/Utils/ViewDetected';

// styles
import styles from './ModalSuccess.module.scss';

interface ModalSuccessProps {}
const ModalSuccess: FunctionComponent<ModalSuccessProps> = () => {
    const { deviceType } = useViewDetected();
    const { isSuccess, setIsSuccess } = useServiceManager();

    const wrapperClassName = classNames([
        styles.wrapper,
        {
            [styles.mobile]: ['mobile', 'tablet'].includes(deviceType),
        },
    ]);
    const onCloseModal = () => {
        setIsSuccess(!isSuccess);

    };
    return (
        <RTModal isOpen={isSuccess} centered contentClassName={wrapperClassName}>
            <ModalBody className={styles.body}>
                <div className={styles.head}>
                    <Image className={styles.banner} src={'assets/dich-vu/icon_success.png'} />
                </div>
                <div className={styles.icon_close} onClick={onCloseModal}>
                    <Image src={'assets/dich-vu/icon_close.png'} />
                </div>
                <div className={styles.content}>
                    <div className={styles.title}>Đăng ký thành công</div>
                    <div className={styles.description}>Đăng ký dịch vụ thành công. Nhân viên của eDoctor sẽ liên hệ lại trong thời gian sớm nhất.</div>
                    <div className={styles.description}>Bạn có muốn xem tin tức hoặc cộng đồng hỏi đáp trong khi chờ tư vấn dịch vụ?</div>
                </div>
                <div className={styles.group_btn}>
                    <a href="/bai-viet" className={styles.btn_health_news}>
                        Tin tức sức khỏe
                    </a>
                    <a href="/hoi-dap" className={styles.btn_community}>
                        Qua trang cộng đồng
                    </a>
                </div>
            </ModalBody>
        </RTModal>
    );
};
export default ModalSuccess;